<template>
  <div class="wrapper">
    <div class="container-fluid" v-if="loader">
      <div class="loader d-flex justify-content-center mb-3 align-items-center">
        <b-spinner
          variant="primary"
          style="width: 3rem; height: 3rem;"
          :label="`${this.$t('reports.loadingLabel')}...`"
          type="grow"
        >
        </b-spinner>
      </div>
    </div>
    <div class="container-fluid" v-else>
      <div class="row">
        <div class="col no-padding">
          <navbar />
        </div>
      </div>
      <div class="row">
        <div class="col-12 content">
          <div id="sidebar-content" class="sidebar">
            <sidebar />
          </div>
          <div class="section">
            <router-view />
          </div>
          <div class="aside">
            <content-aside />
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="alertPopup"
      :title="company.alertPopupTitle"
      size="lg"
      ok-only
    >
      <div v-html="company.alertPopupText"></div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Navbar from '@/components/templates/navbar';
import Sidebar from '@/components/templates/sidebar';
import ContentSection from '@/components/templates/section';
import ContentAside from '@/components/templates/aside';
import * as moment from 'moment';
import eventBus from '../../../eventBus';

export default {
  name: 'Dashboard',
  components: {
    Navbar,
    Sidebar,
    ContentSection,
    ContentAside,
  },
  data: () => ({
    userAuth: null,
    loader: false,
  }),
  computed: {
    ...mapFields('companies', ['company', 'myMetric']),
    ...mapFields('actions', ['actionGroupData', 'allGroups']),
    ...mapFields('settings', ['country']),
    ...mapState('authentication', ['user']),
    ...mapState('users', ['user_data']),
  },
  methods: {
    ...mapActions('authentication', [
      'validateToken',
      'validationProfile',
      'logout',
    ]),
    ...mapActions('companies', ['getCompany']),
    ...mapActions('actions', ['getAllActionGroups']),

    ...mapActions('users', ['getUser']),

    logoutSystem() {
      this.logout(this.userAuth.token);
    },

    changeFavicon(newFaviconUrl) {
      // remove all existing favicons
      const links = document.querySelectorAll('link[rel~="icon"]')
      for (let i = 0; i < links.length; i++) {
        links[i].parentNode.removeChild(links[i])
      }

      let favicon = document.querySelector('link[rel="icon"]')
      if (!favicon) {
        favicon = document.createElement('link')
        favicon.setAttribute('id', 'favicon')
        favicon.setAttribute('rel', 'icon')
        favicon.setAttribute('type', 'image/png')
        document.head.appendChild(favicon)
      }
      favicon.setAttribute('href', newFaviconUrl)
    },

    changeTitle(newTitle) {
      document.title = newTitle;
    }
  },

  // eslint-disable-next-line
  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.loader = true;

    try {
      const data = await this.validateToken(this.userAuth.token);

      await this.validationProfile({ token: this.userAuth.token });

      await this.getCompany({
        id: this.userAuth.companyId,
        token: this.userAuth.token,
      });

      await this.getUser({
        token: this.userAuth.token,
        userId: this.userAuth._id,
      });

      // verificar se SSO está habilitado não ignorar two-factor, senha expirada
      if (!this.company.SSO) {
        // verificar se tem two factor nao finalizado
        if (this.company.enableTwoFactor && this.user_data.twoFactorCode)
          return this.$router.push({
            name: 'Two Factor',
            params: {
              email: this.user_data.email,
              companyId: this.userAuth.companyId,
            },
          });

        // verifiar se é necessário trocar a senha (primeiro acesso, etc...)
        if (this.user_data.changePassword)
          return this.$router.push({
            name: 'Senha Expirada',
            params: { email: this.user_data.email },
          });

        // verificar se a senha expirou
        const expiratePasswordDays = this.company.expirateTimePassword;
        if (expiratePasswordDays && expiratePasswordDays > 0) {
          const diff = moment(moment(), 'DD/MM/YYYY HH:mm:ss').diff(
            moment(
              moment(this.user_data.lastChangePassword),
              'DD/MM/YYYY HH:mm:ss',
            ),
          );

          if (moment.duration(diff).asDays() >= expiratePasswordDays)
            return this.$router.push({
              name: 'Senha Expirada',
              params: { email: this.user_data.email },
            });
        }
      }

      if (this.company.faviconUrl) {
        this.changeFavicon(this.company.faviconUrl);
        this.changeTitle(this.company.name);
      }

      this.country = data.user.country;

      this.myMetric = this.company.favoriteMetric;

      if (this.company.favoritePeriod) {
        this.$store.state.calendar.calendarDates.selected = this.company.favoritePeriod;
      } 

      await this.getAllActionGroups({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        params: {
          menuAside: true,
        },
      });
      this.$i18n.locale = this.country;
      // if (this.$store.state.actions.myActionId === '0') {
      //   this.$store.state.actions.myActionName = this.$t(
      //     'menu.allActionsLabel',
      //   );
      // }

      if (this.$store.state.actions.myActionsIds.length === 0) {
        this.$store.state.actions.myActionName = this.$t(
          'menu.allActionsLabel',
        );
      }
      if (this.$store.state.actions.actionGroupData._id == null) {
        this.$store.state.actions.actionGroupData.name = this.$t(
          'actionList.actionTable.noClassifiedLabel',
        );
      }
      if (this.$store.state.actions.favouriteGroup._id == null) {
        this.$store.state.actions.favouriteGroup.name = this.$t(
          'actionList.actionTable.noClassifiedLabel',
        );
      }
      for (let i = 0; i < this.$store.state.actions.allGroups.length; i += 1) {
        if (this.$store.state.actions.allGroups[i]._id == null) {
          this.$store.state.actions.allGroups[i].name = this.$t(
            'actionList.actionTable.noClassifiedLabel',
          );
        }
      }
      const isShowPopup = localStorage.getItem('alertPopup');

      if (isShowPopup && isShowPopup === 'true') {

        // verificar se o alerta vai ser exibido para todos ou somente admin's
        const onlyAdmins = this.company.alertPopupAdmin;

        if(onlyAdmins){

          // mostrar somente para admin's
          if(this.userAuth.type === 'admin'){
            this.$bvModal.show('alertPopup');
          }

          // mostrar para todos
        } else {
          this.$bvModal.show('alertPopup');
        }

        setTimeout(() => {
          localStorage.removeItem('alertPopup');
        }, 1000);
      }
      this.loader = false;
    } catch (error) {
      window.console.log(error);
      localStorage.setItem('_indecx', JSON.stringify({ auth: false }));

      const returnUrl = this.$route.fullPath;
      if(returnUrl && returnUrl.includes('treatments/')) {
        localStorage.setItem('returnUrl', returnUrl);
      }
      this.$router.push('/');
    }
  },

  mounted() {
    setTimeout(this.logoutSystem, 43200000);

    eventBus.$on('change-padding', (isPanel) => {
      if (isPanel) {
        const changeElement = document.querySelectorAll('.section')[0];
        changeElement.style.padding = '0';
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/placeholders.scss';
@import '@/themes/default/variables.scss';
@import '@/themes/default/mixins.scss';

.content {
  display: flex;
  width: 100%;
  overflow: hidden;
  padding: 0;
  height: calc(100vh - 62px);
  @media screen and (max-width: 575px) {
    height: calc(100vh - 58.4px);
  }
  .sidebar {
    width: 95px;
    transition: all 0.2s linear;
  }
  .section {
    padding: 10px;
    overflow: auto;
    overflow-x: hidden;
    flex: 15;
    @include bg-color($gray-lighter);
  }
}
.no-padding {
  @extend %no-padding;
}

.loader {
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/index.vue